export default __webpack_public_path__ + "static/media/20year.ce1c00b7.svg";